import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserInfoBuilder,
  addDailyCreditsBuilder,
  sendCodeBuilder,
  verifyEmailBuilder,
  generateCollectionBuilder,
  setUsernameBuilder,
  deleteAccountBuilder,
  getReferralUsersBuilder,
  updateTrainModelBuilder,
  toggleToFavoriteBuilder,
  regenerateCollectionBuilder,
  refreshBuilder,
  spinTheWheelBuilder,
  generateEditImageCollectionBuilder,
  regenerateEditImageCollectionBuilder,
  generateAnonymizeCollectionBuilder,
  getSameAuthorCollectionsBuilder,
  submitRequestBuilder,
} from "./builder";
import { LOGOUT } from "../../../utils/constants";

const INIT_STATE = {
  user: null,
  referralEarnings: {
    data: [],
    total: 0,
    perPage: 0,
    page: 0,
    maxReached: false,
  },

  sameAuthorCollections: {
    data: null,
    loading: true,
    error: null,
  },

  addDailyCreditsPending: false,
  spinTheWheelPending: false,
  fetchUserInfoPending: false,
  setUsernamePending: false,
  deleteAccountPending: false,
  getReferralUsersPending: true,
  submitRequestLoading: false,
};

export const userSlice = createSlice({
  name: "userInfo",
  initialState: INIT_STATE,
  reducers: {
    resetState: () => INIT_STATE,

    setUserCredits: (state, { payload }) => {
      state.user.credits = payload;
    },
    addUserCredits: (state, { payload }) => {
      if (state.user.credits + parseInt(payload) >= 0) {
        state.user.credits = state.user.credits + parseInt(payload);
      }
    },
  },
  extraReducers: (builder) => {
    fetchUserInfoBuilder(builder);
    sendCodeBuilder(builder);
    generateCollectionBuilder(builder);
    regenerateCollectionBuilder(builder);
    verifyEmailBuilder(builder);
    addDailyCreditsBuilder(builder);
    setUsernameBuilder(builder);
    deleteAccountBuilder(builder);
    getReferralUsersBuilder(builder);
    updateTrainModelBuilder(builder);
    toggleToFavoriteBuilder(builder);
    refreshBuilder(builder);
    spinTheWheelBuilder(builder);
    generateEditImageCollectionBuilder(builder);
    regenerateEditImageCollectionBuilder(builder);
    generateAnonymizeCollectionBuilder(builder);
    getSameAuthorCollectionsBuilder(builder);
    submitRequestBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE, user: undefined }));
  },
});

export const { resetState, setUserCredits, addUserCredits } = userSlice.actions;

export const selectUser = (state) => state.userInfo.user;
export const selectAddDailyCreditsLoading = (state) =>
  state.userInfo.addDailyCreditsPending;

export const selectSpinTheWheelLoading = (state) =>
  state.userInfo.spinTheWheelPending;

export const selectSubmitRequestLoading = (state) =>
  state.userInfo.submitRequestLoading;

export const selectSameAuthorCollections = (state) =>
  state.userInfo.sameAuthorCollections;

export const selectSetUsernamePending = (state) =>
  state.userInfo.setUsernamePending;

export const selectDeleteAccountPending = (state) =>
  state.userInfo.deleteAccountPending;

export const selectGetReferralUsersPending = (state) =>
  state.userInfo.getReferralUsersPending;

export const selectReferralEarnings = (state) =>
  state.userInfo.referralEarnings;

export default userSlice.reducer;
